import React, { Component } from 'react';
import { connect } from 'react-redux';
import translate from './TranslateHOC';
import { PATH_SIGN_IN, PATH_SIGN_UP } from '../constants';
import { Link } from 'react-router-dom';
import Isvg from 'react-inlinesvg';
import close from '../img/icons/close.svg';
import { loginRedriect } from '../actions';
import { IsvgWrapper } from '../helpers';


class ProgSignUpModal extends Component {

	componentDidMount = () => {
		this.props.loginRedriect(this.props.loginRedirect);
	}

	render() {
		const { strings, toggleThis } = this.props


		return (
			<div className="programme__sign-up dialog__overlay">


				<div className="dialog__content" tabIndex="-1" role="dialog" aria-label={ strings.progSignUpTitle }>
					<div className="dialog--confirm">
						<span onClick={ toggleThis } className={"icon-holder"}>
							<IsvgWrapper addClasses='icon'>
								<Isvg src={ close } />
							</IsvgWrapper>
						</span>
						<div className="dialog__title">{ strings.progSignUpTitle }</div>
						<div className="dialog__instruction">{ strings.progSignUpInstruction }</div>
						<div className="dialog__actions">
							<Link
								to={PATH_SIGN_IN}
							>{ strings.logIn }</Link> { strings.or } &nbsp;
							<Link
								to={PATH_SIGN_UP}
							className="btn">{ strings.signUpNow }</Link>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		loginRedriect: (url) => dispatch(loginRedriect(url))
	};
};

export default translate( connect(null, mapDispatchToProps)(ProgSignUpModal));
